import { loading } from 'State/actions';
import * as types from './types';

export const getStudents = siteId => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.PROHIBITED_ITEMS_REPORT_GRID_LOADING, true));

    try {
      const response = await MPWWebApi.getGeneric(
        `reports/${siteId}/prohibitedstudents/`
      );

      dispatch({
        type: types.PROHIBITED_ITEMS_REPORT_GET_STUDENTS,
        payload: {
          data: response.data.Data,
          siteId,
        },
      });
    } catch (error) {
      dispatch({
        type: types.PROHIBITED_ITEMS_REPORT_GRID_ERROR,
        payload: error,
      });
    }

    dispatch(loading(types.PROHIBITED_ITEMS_REPORT_GRID_LOADING, false));
  };
};

export const toggleStudentChecked = idSeed => {
  return {
    type: types.PROHIBITED_ITEMS_REPORT_TOGGLE_STUDENT_CHECKED,
    payload: idSeed,
  };
};

export const toggleCheckAll = displayedStudents => {
  return {
    type: types.PROHIBITED_ITEMS_REPORT_TOGGLE_CHECK_ALL,
    payload: displayedStudents,
  };
};



// WEBPACK FOOTER //
// ./src/pages/prohibiteditems/state/page/actions.js